var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"evaluate-list"},_vm._l((_vm.items),function(exp){return _c('postItem',{key:exp.id,attrs:{"ommitContent":true,"experience":exp,"imgLog":true}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }